import type { AspectRatioRange } from '~publish/legacy/media/aspect-ratio/types'
import { VALIDATION_CODE } from '~publish/legacy/validation/constants'
import ValidationFail from '~publish/legacy/validation/ValidationFail'

import {
  getAspectRatio,
  getAspectRatioString,
  isRatioWithinRange,
} from '../../aspect-ratio/aspect-ratio'
import { ValidationRuleName } from '../types'
import type { AspectRatioRangeRule } from '../types'
import { createRuleHandler } from './createRuleHandler'
import { getRuleMessages } from './getRuleMessages'

export const aspectRatioRange = createRuleHandler<AspectRatioRangeRule>({
  ruleName: ValidationRuleName.AspectRatioRange,
  messages: {
    specific:
      'This image does not meet the expected aspect ratios ({min} to {max})',
    generic:
      "One or more images aren't matching the expected aspect ratios ({min} to {max})",
  },
  validate: (rule, media) => {
    const width = Number(media.width)
    const height = Number(media.height)

    // Skip validation when dimensions aren't loaded yet
    if (width <= 0 || height <= 0) return null

    const ratio = getAspectRatio({ width, height })

    const expected: AspectRatioRange = {
      minRatio: getAspectRatio(rule.ruleConfig.min),
      maxRatio: getAspectRatio(rule.ruleConfig.max),
    }

    if (!isRatioWithinRange({ ratio, range: expected })) {
      const messages = getRuleMessages(rule, { toString: getAspectRatioString })

      return new ValidationFail(
        messages.generic,
        VALIDATION_CODE.ASPECT_RATIO,
        messages,
        {},
      )
    }

    return null
  },
})
